import styles from './styles.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
        <div className={styles.container}>
            <div className={styles.block}>
                <h3>Social links</h3>
                <a className={styles.link} href="https://discord.gg/Q8sAHdD6" target="_blank" rel="noopener noreferrer">Discord</a>
                <a className={styles.link} href="https://twitter.com/drzs_nft" target="_blank" rel="noopener noreferrer">Twitter</a>
                <a className={styles.link} href="https://www.instagram.com/drzs_nft/" target="_blank" rel="noopener noreferrer">Instagram</a>
            </div>
            <div className={styles.block}>
                <h3>Marketplaces</h3>
                <a className={styles.link} href="https://magiceden.io/" target="_blank" rel="noopener noreferrer">Magic eden</a>
                <a className={styles.link} href="https://solanart.io/" target="_blank" rel="noopener noreferrer">Solanart</a>
                <a className={styles.link} href="https://opensea.io/" target="_blank" rel="noopener noreferrer">Opensea</a>
        </div>
        </div>
    </footer>
  );
}

export default Footer;
